export const QUESTIONS = [
  { key: 'career', q: 'how would you describe where you are in your career?', options: [
    ['established', "i'm established & people know me for what i do"],
    ['growing', "i've built a solid reputation & i'm still growing"],
    ['figuring_out', "i'm figuring out what i want to be known for"],
  ] },
  { key: 'work', q: 'how do you feel about the work you do?', options: [
    ['love_it', "i love it. i'm not looking to change careers."],
    ['more_options', "i like what i do, but i'd love more options."],
    ['ready_for_different', "honestly, i'm ready for something different."],
  ] },
  { key: 'more_money', q: 'when you want to make more money, what usually has to happen?', options: [
    ['more_hours', 'i work more hours or take on more responsibility'],
    ['raise_rates', 'i ask for a raise, increase my rates or look for a better-paying opportunity'],
    ['another_way', 'i have to find another way to bring money in'],
    ['happy', "i'm happy with what i'm earning right now"],
  ] },
  { key: 'time_off', q: 'if you took two weeks off, what would happen to your income?', options: [
    ['paid_limited', "i'd still get paid, but my time off is limited"],
    ['lose_income', "i'd lose income or have to catch up when i got back"],
    ['keeps_coming', 'my income would keep coming in without much changing'],
  ] },
  { key: 'gift', q: 'which of these comes naturally to you?', options: [
    ['connect', 'bringing people together & making connections'],
    ['mentor', 'mentoring people & helping them grow'],
    ['share', 'sharing things i believe in & getting people excited about them'],
    ['all', 'honestly, a little of all three'],
  ] },
  { key: 'considered', q: 'have you ever considered adding something where your leadership could create another way to earn?', options: [
    ['curious', "no, but now i'm curious"],
    ['where_start', "i've thought about it, but wouldn't know where to start"],
    ['business_model', "yes, but i'd need to understand the business model"],
    ['tried', "i've tried something like that before"],
  ] },
  { key: 'know', q: "before i'd tell you to seriously consider this, what would you need to see?", options: [
    ['comp', 'how the compensation plan works'],
    ['day_to_day', "what i'd actually be doing day to day"],
    ['support', "what kind of training & support i'd have"],
    ['company', 'what the company is & what it sells'],
    ['all', 'honestly, all of the above'],
  ] },
  { key: 'want', multi: true, q: 'if you could create more options for yourself, what would you want most?', options: [
    ['family', 'more time with my family'],
    ['breathing_room', 'more financial breathing room'],
    ['flexibility', 'more flexibility with my schedule'],
    ['another_way', "another way to earn that isn't tied directly to my hours"],
    ['different', 'the freedom to make my career look different down the road'],
  ] },
];

export const IDS_URL = 'https://monatglobal.com/income-disclosure-statement/';

export const VIDEOS = {
  comp: { phrase: 'how the compensation works', title: 'how the compensation works', src: 'https://www.youtube-nocookie.com/embed/Epjl5qLvZEc', caption: '1 min · from my ready to run breakdown · income isn\u2019t guaranteed.', ids: true },
  day_to_day: { phrase: 'what the day-to-day actually looks like', title: 'what i actually do day to day', src: 'https://www.youtube-nocookie.com/embed/hp3lg5c26Os', caption: '30 sec · from my ready to run breakdown' },
  support: { phrase: "the training & support you'd have", title: "the training & support you'd have", src: 'https://www.youtube-nocookie.com/embed/gAPJ8vOJA-w', caption: '1 min · from my ready to run breakdown' },
  company: { phrase: 'what the company is & what it sells', title: 'the company & what it sells', src: 'https://www.youtube-nocookie.com/embed/HHv7Tp7N-AI', caption: '1 min · from my ready to run breakdown' },
};
export const VIDEO_ORDER = ['comp', 'day_to_day', 'support', 'company'];

export const TAKE_LINES = {
  not_now: "honestly? i don't think this is the right fit right now.",
  products_first: "i wouldn't tell you to jump into this yet. i'd start by understanding the products & the company.",
  full_model: "i think you'd want to see the full business model before deciding whether this fits.",
  closer_look: 'i think this is worth a closer look.',
};

export const pickTake = (a) => {
  if (a.more_money === 'happy' && a.time_off === 'keeps_coming') return 'not_now';
  if (a.career === 'figuring_out' || a.know === 'company') return 'products_first';
  if (['business_model', 'tried'].includes(a.considered) || ['comp', 'all'].includes(a.know)) return 'full_model';
  return 'closer_look';
};

const GIFT = {
  connect: 'you bring people together',
  mentor: 'you mentor people & help them grow',
  share: 'you get people excited about what you believe in',
  all: 'you do a little of all three: connecting, mentoring & sharing',
};

export const whyText = (take, a) => {
  const gift = GIFT[a.gift];
  if (take === 'not_now') return "you're happy with what you're earning & your income keeps coming in when you step away. that's a great place to be, & i wouldn't mess with it.";
  if (take === 'products_first') {
    if (a.career === 'figuring_out') return `you're still figuring out what you want to be known for, & ${gift}. i'd get to know the products first & see how they feel to you.`;
    return `you'd want to know what the company is & what it sells before anything else. smart. and since ${gift}, you'll know pretty fast if you'd stand behind the products.`;
  }
  const rep = a.career === 'established' ? 'people already know you for what you do' : "you've built a solid reputation";
  let t = `${rep}, and ${gift}. those skills matter in this business.`;
  if (a.time_off === 'lose_income') t += ' and right now, your income depends on you showing up.';
  if (a.time_off === 'paid_limited') t += ' and right now, your time off is limited.';
  return t;
};

const WANT_SINGLE = {
  family: 'you said more time with your family 🤍',
  breathing_room: 'you said more financial breathing room.',
  flexibility: 'you said more flexibility with your schedule ☀️',
  another_way: "you said another way to earn that isn't tied to your hours. same reason heidi on my team started (she's paying off debt).",
  different: 'you said the freedom to make your career look different down the road. same reason michelle on my team started.',
};
const WANT_PHRASE = {
  family: 'more time with your family',
  breathing_room: 'more financial breathing room',
  flexibility: 'more flexibility with your schedule',
  another_way: "another way to earn that isn't tied to your hours",
  different: 'the freedom to make your career look different down the road',
};
const WANT_ORDER = ['family', 'breathing_room', 'flexibility', 'another_way', 'different'];

const joinAnd = (xs) => (xs.length === 1 ? xs[0] : `${xs.slice(0, -1).join(', ')} & ${xs[xs.length - 1]}`);

export const wantText = (take, wants) => {
  const picked = WANT_ORDER.filter((w) => wants.includes(w));
  const sentence = `you said ${joinAnd(picked.map((w) => WANT_PHRASE[w]))}.`;
  if (take === 'not_now') {
    const base = picked.length === 1 && ['family', 'flexibility', 'breathing_room'].includes(picked[0]) ? WANT_SINGLE[picked[0]] : sentence;
    return `${base} keep that in your back pocket.`;
  }
  if (picked.length === 1) return WANT_SINGLE[picked[0]];
  const heidi = picked.includes('another_way');
  const michelle = picked.includes('different');
  if (heidi && michelle) return `${sentence} same reason heidi on my team started (she's paying off debt), & michelle too.`;
  if (heidi) return `${sentence} same reason heidi on my team started (she's paying off debt).`;
  if (michelle) return `${sentence} same reason michelle on my team started.`;
  return sentence;
};
